import { PaginatedColumn } from '../types/app';
import { FleetAssetDocumentStatus } from '../types/fleet';
import { getOptionsFromObject } from '../utils/objects';
import { capitalize } from '../utils/strings';
import { ASSET_TYPE_CONTAINER, ASSET_TYPE_VEHICLE } from './asset';

export const TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: 'Etiqueta',
    key: 'label',
    minWidth: 300,
    maxWidth: 300,
  },
  {
    label: 'VIN',
    key: 'vin',
    minWidth: 200,
    maxWidth: 200,
  },
  {
    label: 'Marca',
    key: 'brand',
    minWidth: 160,
    maxWidth: 160,
  },
  {
    label: 'Submarca',
    key: 'subBrand',
    minWidth: 160,
    maxWidth: 160,
  },
  {
    label: 'Placas',
    key: 'plate',
    minWidth: 140,
    maxWidth: 140,
  },
  {
    label: 'Icono',
    key: 'icon',
    minWidth: 70,
    centered: true,
  },
  {
    label: 'Odómetro',
    key: 'odometer',
    minWidth: 150,
  },
  {
    label: 'Valor comercial',
    key: 'odometer',
    minWidth: 150,
  },
  {
    label: 'Documentación',
    key: 'documents',
    minWidth: 150,
  },
  {
    label: 'Último mantenimiento',
    key: 'lastMaintenance',
    minWidth: 160,
    maxWidth: 160,
  },
  {
    label: 'Última reparación',
    key: 'lastReparation',
    minWidth: 130,
    maxWidth: 130,
  },
  {
    label: 'Acciones',
    key: 'actions',
    minWidth: 140,
    maxWidth: 140,
    centered: true,
  },
];

const FLEET_ASSET_TYPE = {
  [ASSET_TYPE_VEHICLE]: 'vehículo',
  [ASSET_TYPE_CONTAINER]: 'contenedor',
};

export const FLEET_ASSET_TYPE_OPTIONS = getOptionsFromObject(FLEET_ASSET_TYPE).map((type) => ({
  ...type,
  label: capitalize(type.label),
}));

export const FLEET_ASSET_DOCUMENT_STATUS_LABEL = {
  [FleetAssetDocumentStatus.valid]: 'Vigente',
  [FleetAssetDocumentStatus.about_to_expire]: 'Expira pronto',
  [FleetAssetDocumentStatus.expired]: 'Expirado',
};
